import { ChangeRequestDtoStatusEnum } from "../../../api";

export type ChangeRequestStatus = ChangeRequestDtoStatusEnum;

const { Draft, Pending, ChangesRequested, Approved, Rejected, Cancelled } =
  ChangeRequestDtoStatusEnum;

export function isEditable(status: ChangeRequestStatus): boolean {
  return status === Draft || status === ChangesRequested;
}

export function isSubmittable(status: ChangeRequestStatus): boolean {
  return status === Draft || status === ChangesRequested;
}

export function isCancellable(status: ChangeRequestStatus): boolean {
  return status === Draft || status === Pending || status === ChangesRequested;
}

export function isInReview(status: ChangeRequestStatus): boolean {
  return status === Pending;
}

export function isReviewable(status: ChangeRequestStatus): boolean {
  return status === Pending;
}

export function isHistorical(status: ChangeRequestStatus): boolean {
  return status === Approved || status === Rejected || status === Cancelled;
}

export function humanizeStatus(status: ChangeRequestStatus): string {
  switch (status) {
    case Draft:
      return "Draft";
    case Pending:
      return "Pending review";
    case ChangesRequested:
      return "Changes requested";
    case Approved:
      return "Approved";
    case Rejected:
      return "Rejected";
    case Cancelled:
      return "Cancelled";
    default:
      return status;
  }
}
